import { convertMathJax } from '~/lib/utils/mathjax';
export const useMathJax = (
  element: Ref<HTMLElement> | HTMLElement,
  onRenderComplete = null
) => {
  onMounted(async () => {
    const elt = toValue(element);
    const domElt = elt.$el || elt;
    setTimeout(() => convertMathJax(domElt, onRenderComplete), 100);
  });
};
